// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hide-cursor {
  cursor: none;
}
.needs-page-button {
  white-space: nowrap;
  border-radius: 0.3rem;
  background-color: #999;
  color: white;
  font-weight: 400;
  font-size: 0.8rem;
  padding: 0.5rem;
  min-width: 7rem;
  border: none;
  @media screen and (max-width: 560px) {
    min-width: auto;
  }
}
.needs-page-button:hover {
  background-color: #aaa;
}
.needs-page-button:active {
  background-color: #666;
}
`, "",{"version":3,"sources":["webpack://./components/css/utils.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,YAAY;EACZ;IACE,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".hide-cursor {\n  cursor: none;\n}\n.needs-page-button {\n  white-space: nowrap;\n  border-radius: 0.3rem;\n  background-color: #999;\n  color: white;\n  font-weight: 400;\n  font-size: 0.8rem;\n  padding: 0.5rem;\n  min-width: 7rem;\n  border: none;\n  @media screen and (max-width: 560px) {\n    min-width: auto;\n  }\n}\n.needs-page-button:hover {\n  background-color: #aaa;\n}\n.needs-page-button:active {\n  background-color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
